import { create } from "zustand";

export const useTableStore = create((set) => ({
	// this store is for table data/functionalities

	// data
	tableData: [],
	setTableData: (tableData) => set({ tableData: tableData }),


	isTableLoading: true,
	setIsTableLoading: (isTableLoading) => set({ isTableLoading: isTableLoading }),

	// functionalities
	onCellDataSave: undefined,
	setOnCellDataSave: (onCellDataSave) => set({ onCellDataSave: onCellDataSave }),

	onCellEdit: undefined,
	setOnCellEdit: (onCellEdit) => set({ onCellEdit: onCellEdit }),

	onDropdownClick: undefined,
	setOnDropdownClick: (onDropdownClick) => set({ onDropdownClick: onDropdownClick }),

	onDropdownOpen: undefined,
	setOnDropdownOpen: (onDropdownOpen) => set({ onDropdownOpen: onDropdownOpen }),
}))